// @ts-strict-ignore
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import { FcPermissionCode } from '@fc-core/models/permission.model';
import { getCurrentEmployee } from '@fc-store/selectors';
import { hasPermission } from '@fc-shared/utils/data.utils';

export function hasPermissionGuard(
  codename: FcPermissionCode,
  redirectTo: string = '/dashboard',
): CanActivateFn {
  return () => {
    const store = inject(Store);
    const router = inject(Router);
    return store.select(getCurrentEmployee).pipe(
      filter((employee) => employee !== null),
      take(1),
      map((employee) => {
        const havePermission = hasPermission(employee.permissions, codename);
        if (!havePermission) router.navigate([redirectTo]);
        return havePermission;
      }),
    );
  };
}
